import * as yup from 'yup'

export const ResellerSchmea = yup.object().shape({
  resellerID:yup.string().min(3,"1:ResellerID must include atleast 3 characters").matches(/^[a-zA-Z0-9]+$/, '9:No special characters allowed').required("2:ResellerID is required")
});

export const BaseStationSchema = yup.object().shape({
  id:yup.string().matches(/^(?=.*[a-zA-Z])(?=.*\d).+$/,"4:Base Station MAC must be AlphaNumeric").min(12,"3:Base Station MAC must include 12 characters").matches(/^[a-zA-Z0-9]+$/, '4:No special characters allowed').required("5:Base Station MAC is required")
});

export const BeaconSchema = yup.object().shape({
    id:yup.string().matches(/^(?=.*[a-zA-Z])(?=.*\d).+$/,"7:Beacon MAC must be AlphaNumeric").min(12,"6:Beacon MAC must include 12 characters").matches(/^[a-zA-Z0-9]+$/, '7:No special characters allowed').required("8:Beacon MAC is required")

});